import styled from '@emotion/styled';

export default styled('button')`
	cursor: pointer;
	display: block;
	font-family: inherit;
	font-size: 16px;
	font-weight: 500;
	height: 40px;
	margin: 0 auto;
	padding: 0;

	${props => props.theme.button || ''}
`;
